import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserControls from 'flarum/forum/utils/UserControls';
import Button from 'flarum/common/components/Button';
import RequestDataExportModal from '../../common/components/RequestDataExportModal';
import DeleteUserModal from '../components/DeleteUserModal';
export default function extendUserControls() {
  extend(UserControls, 'moderationControls', function (items, user) {
    if (user.canModerateExports()) {
      items.add('gdpr-export', m(Button, {
        icon: "fas fa-file-export",
        onclick: () => app.modal.show(RequestDataExportModal, {
          user
        })
      }, app.translator.trans('flarum-gdpr.forum.settings.export_data_button')));
    }
  });
  extend(UserControls, 'destructiveControls', function (items, user) {
    items.remove('delete');
    if (user.canDelete()) {
      items.add('gdpr-erase', m(Button, {
        icon: "fas fa-eraser",
        onclick: () => app.modal.show(DeleteUserModal, {
          user
        })
      }, app.translator.trans('flarum-gdpr.forum.delete_user.delete_button')));
    }
  });
}
flarum.reg.add('flarum-gdpr', 'forum/extenders/extendUserControls', extendUserControls);